import React, { useState, useEffect } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { dataAPI } from "../../api/axios";
import "./Attachments.css";

const DeleteAttachment = ({
    setNewAttachments,
    setDialogContext,
    attachmentId,
    layerID,
    objectID,
    attachmentOID,
    parentHandleDelete,
}) => {
    const [dialogType, setDialogType] = useState(); // 'confirm', 'success', or 'error'
    const [statusMessage, setStatusMessage] = useState({ type: "", message: "" });
    const [deleteSuccessful, setDeleteSuccessful] = useState(false);

    const handleDelete = async () => {
        try {
            if (!attachmentId || !attachmentOID) {
                throw new Error(
                    "Failed to delete attachment: attachmentId or attachmentOID not defined"
                );
            }

            const response = await dataAPI.delete(
                `/Layers/${layerID}/Data/${objectID}/Attachments/${attachmentId}/${attachmentOID}`
            );

            if (response.status === 204) {
                setStatusMessage({
                    type: "success",
                    message: "Attachment deleted successfully",
                });
                setDialogType("success");
                setDialogContext("viewAttachment");
                setDeleteSuccessful(true);
            }
        } catch (error) {
            console.error("Failed to delete attachment:", error);
            setStatusMessage({ type: "error", message: error.message });
            setDialogType("error");
        }
    };

    useEffect(() => {
        if (deleteSuccessful) {
            parentHandleDelete(attachmentOID);

            setNewAttachments((prevAttachments) =>
                prevAttachments.filter((attachment) => attachment.id !== attachmentOID)
            );

            setDialogType("success");
            setDeleteSuccessful(false);

            setDialogContext();
            setDialogContext("viewAttachment");
        }
    }, [
        deleteSuccessful,
        parentHandleDelete,
        setNewAttachments,
        setDialogContext,
        attachmentOID,
    ]);

    const renderDialog = () => {
        switch (dialogType) {
            case "confirm":
                return (
                    <Dialog title={"Please confirm"} onClose={() => setDialogType(null)}>
                        <p style={{ margin: "25px", textAlign: "center" }}>
                            Are you sure you want to delete this attachment?
                        </p>
                        <DialogActionsBar>
                            <Button title="Yes" onClick={handleDelete}>
                                Yes
                            </Button>
                            <Button title="No" onClick={() => setDialogType(null)}>
                                No
                            </Button>
                        </DialogActionsBar>
                    </Dialog>
                );
            case "success":
            case "error":
                return (
                    <Dialog title={dialogType} onClose={() => setDialogType(null)}>
                        <p style={{ margin: "25px", textAlign: "center" }}>
                            {statusMessage.message}
                        </p>
                        <DialogActionsBar>
                            <Button title="OK" onClick={() => setDialogType(null)}>
                                OK
                            </Button>
                        </DialogActionsBar>
                    </Dialog>
                );
            default:
                return null;
        }
    };

    return (
        <>
            <Button onClick={() => setDialogType("confirm")}>Delete</Button>
            {renderDialog()}
        </>
    );
};

export default DeleteAttachment;
